import request from '@/utils/request'

/**
 * 分页
 * @param {*} data
 * @returns
 */
export function page(data) {
  return request({
    url: '/mg/drp-user-api/employee/page',
    method: 'post',
    allowRepeat: true,
    data,
  })
}
/**
 * 门店
 * @param {*} data
 * @returns
 */
export function retailShopList(data) {
  return request({
    url: '/mg/daohang-basic-api/retailShop/list',
    method: 'post',
    data: {...data, t: new Date().getTime() },
  })
}
/**
 * 保存
 * @param {*} data
 * @returns
 */
export function save(data) {
  return request({
    url: `/mg/daohang-basic-api/employee/saveOrUpdate`,
    method: 'put',
    loading: true,
    data,
  })
}

/**
 * 保存
 * @param {*} data
 * @returns
 */
export function changeStatus(data) {
  return request({
    url: '/mg/drp-user-api/employee/status',
    method: 'put',
    loading: true,
    data,
  })
}
/**
 * 详情
 * @param {*} id
 * @returns
 */
export function detail(id) {
  return request({
    url: `/mg/drp-user-api/employee/${id}`,
    method: 'get',
  })
}
/**
 * 保存
 * @param {*} 导出
 * @returns
 */
export function pageExport(data) {
  return request({
    url: '/mg/daohang-basic-api/employee/exportExcel',
    method: 'post',
    responseType: 'blob',
    data,
  })
}

/**
 * 员工关联门店查询
 * @param {*} params
 * @returns
 */
export function relevanceShop(params) {
  return request({
    url: `/mg/daohang-basic-api/employee/relevanceShop`,
    method: 'get',
    params,
  })
}

//新增编辑员工岗位条件查询
export function postListByDept(data) {
  return request({
    url: `/mg/drp-user-api/postInfo/list`,
    method: 'post',
    data,
  })
}
//新增编辑员工岗位条件查询
export function regainPassWord(data) {
  return request({
    url: `/mg/drp-user-api/userAccount/regainPassWord`,
    method: 'put',
    data,
  })
}
//新增编辑员工岗位条件查询
export function currentShopEmployee(params) {
  return request({
    url: `/mg/daohang-basic-api/employee/currentShopEmployee`,
    method: 'GET',
    params,
  })
}
//新增编辑员工岗位条件查询
export function currentShopEmployeeList(data) {
  return request({
    url: `/mg/daohang-basic-api/employee/currentShopEmployee/list`,
    method: 'POST',
    data,
  })
}
/**
 * 刷新门店token
 * @returns
 */
export function refreshShopToken() {
  return request({
    url: `/mg/daohang-basic-api/employee/refreshShopToken`,
    method: 'GET',
  })
}
